import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { createUniqueCustomProperties } from '../../../utils/createUniqueCustomProperty';
import { Animation, Colors } from '../../../theme';
import { FormLabel } from '../../forms/FormLabel';
import { BooleanInput } from './BooleanInput';
const Vars = createUniqueCustomProperties('LabeledBooleanInput', [
    'outlineColor',
]);
const Styles = labelStyles('LabeledBooleanInput', {
    root: css `
    ${Vars.outlineColor}: transparent;
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px;
    align-items: center;
    padding: 10px 8px;
    min-height: 0;

    // This is the outline that renders around the label when
    // it's focused. It's a pseudo element to preserve transparency
    // between the edge of the label and the edge of the outline.
    // It's defined here vs only in ':focus-with' so that it can transition
    // between states.
    &::before {
      content: '';
      position: absolute;
      pointer-events: none;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 2px solid var(${Vars.outlineColor});
      border-radius: 3px;
      transition: ${Animation.transitionValue};
    }

    &:focus-within {
      ${Vars.outlineColor}: ${Colors.blue};

      &[data-errored] {
        ${Vars.outlineColor}: ${Colors.error};
      }
    }
  `,
});
export const LabeledBooleanInput = (props) => {
    return (isolateComponent(FormLabel, { isDisabled: props.isDisabled, isErrored: props.isErrored, isRequired: props.isRequired, isSelected: props.checked, justifyContent: "stretch" },
        isolateComponent("span", { css: Styles.root, "data-errored": props.isErrored ? '' : undefined },
            isolateComponent(BooleanInput, { ariaLabel: props.ariaLabel, checked: props.checked, disabled: props.isDisabled, id: props.id, isErrored: props.isErrored, name: props.name, onChange: props.onChange, tabIndex: props.tabIndex, type: props.type, value: props.value }),
            props.children)));
};
LabeledBooleanInput.defaultProps = {
    checked: false,
    onChange: () => { },
    tabIndex: 0,
};
//# sourceMappingURL=LabeledBooleanInput.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
